__turbopack_context__.v({
  "container": "TSKYkq_container",
  "content": "TSKYkq_content",
  "footer": "TSKYkq_footer",
  "hostDetails": "TSKYkq_hostDetails",
  "hostEmailField": "TSKYkq_hostEmailField",
});
